import { FC, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { requestNotificationPermission } from "../../firebase/utility/firebaseMessaging";

export const HomePage: FC = () => {
  useEffect(() => {
    // Register the service worker and wait until it's ready
    navigator.serviceWorker.ready.then((registration) => {
      console.log("Service Worker is ready", registration);

      // Request notification permission and handle token
      requestNotificationPermission();
    });
  }, []);

  return (
    <Box sx={{ mt: 10 }}>
      <Typography variant="h2" align="center" margin={5} marginBottom={5}>
        Welkom op de homepage van het LCCU GSM-tracking beheer.
      </Typography>
      <Typography variant="h6" align="center" sx={{ marginBottom: 2 }}>
        Hier kunt u uw GSM's beheren en toevoegen.
      </Typography>
      <Typography variant="h6" align="center" sx={{ marginBottom: 2 }}>
        Voor een toestel toe te voegen gaat U via de navigatie naar GSM.
      </Typography>
    </Box>
  );
};

export default HomePage;
